// @ts-nocheck
/**
 * Ludipek B2B pending-approval gate.
 *
 * When a customer is logged in but has no NetSuite link yet (custom.netsuite_id blank),
 * window.__LUDIPEK_B2B__.isPending is true and <body> carries the `b2b-pending` class.
 * CSS hides prices, disables add-to-cart buttons, and hides the cart icon — that's the
 * primary gate.
 *
 * This script is the belt-and-braces JS layer:
 *   1. Intercept POST /cart/add.js (from any theme/extension) and short-circuit it.
 *   2. Show a non-blocking toast explaining why the action was refused.
 *   3. Also intercept form.submit() on any <form action="/cart/add"> for themes that
 *      post the form directly instead of via fetch.
 */
(function () {
  const BOOTSTRAP = window.__LUDIPEK_B2B__ || null;
  if (BOOTSTRAP === null || BOOTSTRAP.isPending !== true) return;

  const TOAST_ID = 'b2b-pending-toast';
  const TOAST_TIMEOUT_MS = 4000;

  function toastMessage() {
    return (
      (BOOTSTRAP.messages && BOOTSTRAP.messages.pendingAddToCartBlocked) ||
      'Your B2B account is pending approval.'
    );
  }

  function showToast() {
    let toast = document.getElementById(TOAST_ID);
    if (toast === null) {
      toast = document.createElement('div');
      toast.id = TOAST_ID;
      toast.setAttribute('role', 'status');
      toast.style.cssText =
        'position:fixed;bottom:24px;left:50%;transform:translateX(-50%);' +
        'padding:12px 20px;background:rgba(0,0,0,0.85);color:#fff;' +
        'border-radius:6px;font-size:0.95rem;z-index:9999;' +
        'box-shadow:0 4px 16px rgba(0,0,0,0.2);max-width:90vw;';
      document.body.appendChild(toast);
    }
    toast.textContent = toastMessage();
    clearTimeout(toast._timeoutId);
    toast._timeoutId = setTimeout(() => toast.remove(), TOAST_TIMEOUT_MS);
  }

  function isCartAddUrl(input) {
    const url = typeof input === 'string' ? input : input && input.url;
    return typeof url === 'string' && url.includes('/cart/add');
  }

  const originalFetch = window.fetch.bind(window);
  window.fetch = function pendingGateFetch(input, init) {
    if (isCartAddUrl(input)) {
      showToast();
      return Promise.reject(new Error('b2b-pending: add to cart blocked'));
    }
    return originalFetch(input, init);
  };

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      const action = form.getAttribute('action') || '';
      if (action.includes('/cart/add')) {
        event.preventDefault();
        event.stopImmediatePropagation();
        showToast();
      }
    },
    { capture: true }
  );
})();
